import { AfterContentInit, ChangeDetectorRef, Directive, ElementRef, Input } from '@angular/core';
import { MatInput } from '@angular/material/input';

@Directive({
  standalone: true,
  selector: '[automataAutofocus]',
})
export class AutofocusDirective implements AfterContentInit {
  @Input() public appAutofocus: boolean;

  public constructor(private el: ElementRef) {}

  public ngAfterContentInit(): void {
    window.setTimeout(() => {
      this.el.nativeElement.focus();
    }, 0);
  }
}

@Directive({
  standalone: true,
  selector: '[automataMatInputAutofocus]',
})
export class MatInputAutofocusDirective implements AfterContentInit {
  constructor(private matInput: MatInput, private cd: ChangeDetectorRef) {}

  ngAfterContentInit(): void {
    window.setTimeout(() => {
      this.matInput.focus();
      this.cd.detectChanges();
    });
  }
}

@Directive({
  standalone: true,
  selector: '[automataMatInputAutofocusDelayed]',
})
export class MatInputAutofocusDelayedDirective implements AfterContentInit {
  constructor(private matInput: MatInput, private cd: ChangeDetectorRef) {}

  ngAfterContentInit(): void {
    window.setTimeout(() => {
      this.matInput.focus();
      this.cd.detectChanges();
    }, 100);
  }
}
